import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const { lang = "ar" } = useParams();
  const year = 2026;

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-800 bg-[#030F1C] px-4 py-14 text-slate-400 sm:px-6 lg:px-10"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to={`/${lang}`} data-testid="footer-logo-link" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-sm bg-[#C85A32] font-mono text-sm font-bold text-white">
                Z
              </span>
              <span className="font-serif text-xl font-bold text-white">Zynqelix</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
              {t("footer.about")}
            </p>
            <p className="mt-6 text-xs text-slate-500">{t("footer.address")}</p>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-slate-300">
              {t("footer.navTitle")}
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link
                  to={`/${lang}`}
                  data-testid="footer-nav-home"
                  className="hover:text-white"
                >
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <a
                  href={`/${lang}#why`}
                  data-testid="footer-nav-sector"
                  className="hover:text-white"
                >
                  {t("nav.sector")}
                </a>
              </li>
              <li>
                <a
                  href={`/${lang}#circuit`}
                  data-testid="footer-nav-circuit"
                  className="hover:text-white"
                >
                  {t("nav.circuit")}
                </a>
              </li>
              <li>
                <a
                  href={`/${lang}#transparency`}
                  data-testid="footer-nav-transparency"
                  className="hover:text-white"
                >
                  {t("nav.transparency")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-slate-300">
              {t("footer.legalTitle")}
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link
                  to={`/${lang}/privacy`}
                  data-testid="footer-legal-privacy"
                  className="hover:text-white"
                >
                  {t("footer.privacy")}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${lang}/cookies`}
                  data-testid="footer-legal-cookies"
                  className="hover:text-white"
                >
                  {t("footer.cookies")}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${lang}/terms`}
                  data-testid="footer-legal-terms"
                  className="hover:text-white"
                >
                  {t("footer.terms")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-slate-800 bg-[#0A2540]/40 p-5 text-xs leading-relaxed text-slate-400">
          <p className="mb-2 font-mono uppercase tracking-widest text-slate-300">
            {t("footer.companyTitle")}
          </p>
          <div className="grid grid-cols-1 gap-x-6 gap-y-1 md:grid-cols-2">
            <span>{t("footer.companyName")}</span>
            <span>{t("footer.incorporation")}</span>
            <span>{t("footer.registration")}</span>
            <span>{t("footer.cuit")}</span>
            <span>{t("footer.license")}</span>
            <span>{t("footer.mining")}</span>
            <span className="md:col-span-2">{t("footer.jurisdiction")}</span>
          </div>
        </div>

        <p className="mt-6 text-xs text-slate-500">{t("footer.disclaimer")}</p>

        <div className="mt-8 flex flex-col justify-between gap-2 border-t border-slate-800 pt-6 text-xs text-slate-500 sm:flex-row">
          <span>© {year} Zynqelix S.A. {t("footer.rights")}</span>
          <span>zynqelix.com · CABA, Argentina</span>
        </div>
      </div>
    </footer>
  );
}
